import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';

const Sticker = (props) => {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);
  const imgUrl = props.img;
  const title = props.title;
  const titleNoSpace = props.title.replaceAll(" ", "");

  const handleImageLoad = () => {
    setLoaded(true);
  };

  return (
    <Grid size={6}>
      <img
        ref={imgRef}
        src={imgUrl}
        alt={title}
        onLoad={handleImageLoad}
        style={{
          width: "100%",
          maxHeight: "100%",
          opacity: loaded ? 1 : 0,
          transition: "opacity 1s ease-in-out",
        }}
        // loading="lazy"
      />
      <p className={`${titleNoSpace} stickerName`}>{title}</p>
    </Grid>
  );
}

export default Sticker;
